<div
  class="d-flex justify-content-center align-items-center"
  [innerHTML]="_embed"
></div>
